import Vue from 'vue'
import Router from 'vue-router' 

Vue.use(Router)

export default new Router({
  strict: true,
  bmode: 'hash', 
  routes: [
    {
      path: '/',
      component: () => import('@/views/landing/Login'),
    },
    {
      path: '/forgot_password',
      component: () => import('@/views/landing/Forgot_pass'),
    }, 
    {
      path: '*',
      component: () => import('@/views/account/Sorry'),
    },
    {
      // meta: {
      //   requiresAuth: true,
      // },
      path: '/ntsa',
      name: 'NTSA',
      component: () => import('@/views/Ntsa'),
    }, 
    {
      // meta: {
      //   requiresAuth: true,
      // },
      path: '/violations',
      name: 'Violations',
      component: () => import('@/views/Violations'),
    }, 
  ],
})

